module.exports = __webpack_public_path__ + "static/brands-dd5d1f7cd255f3e71402cb368c4f4322.svg";